<template>
    <div v-if="!settings.is_sourcing_mode" class="relative">
        <div class="absolute h-full w-full z-10" aria-hidden="true">
            <img
                src="https://marketing-assets.seclock.com/image/upload/f_auto,q_auto,w_auto/404_bg"
                class="h-full object-cover w-full"
                height="502"
                width="750"
                sizes="750px"
                loading="lazy"
                alt=""
            />
        </div>
        <div
            class="px-4 py-[60px] relative text-center text-white z-20 at1024:px-8 at1024:py-60"
        >
            <h1
                class="flex items-center justify-center mb-10 text-5xl at768:text-[120px]"
            >
                404
            </h1>
            <p class="mb-20 text-2xl at1024:leading-none at1024:text-[60px]">
                Sorry, we can’t find that page.
            </p>
            <ul class="flex gap-3 justify-center">
                <li>
                    <a href="/catalog/products" class="underline hover:text-red"
                        >Products</a
                    >
                </li>
                <li>
                    <a
                        href="/catalog/manufacturers"
                        class="underline hover:text-red"
                        >Manufacturers</a
                    >
                </li>
                <li>
                    <a
                        href="https://support.seclock.com"
                        target="_blank"
                        class="underline hover:text-red"
                        >Support <BaseSvg name="OpenInNew" class="h-5 w-5"
                    /></a>
                </li>
            </ul>
        </div>
    </div>
    <div v-else class="relative">
        <ErrorDisplay
            :error="{
                title: '404',
                message: 'We couldn\'t find that page.'
            }"
        />
    </div>
    <Meta title="Page Not Found" description="Sorry, we can't find that page" />
</template>

<script setup>
import {BaseSvg, Meta, ErrorDisplay} from "@/Components";
import { useUser } from "@/Composables";

const { settings } = useUser();
</script>
